const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (value) => EMAIL_PATTERN.test(String(value || "").trim());

/**
 * Splits a free-typed CC/BCC field into addresses. People paste lists separated by commas,
 * semicolons, or newlines depending on where they copied them from, so all three are accepted.
 */
export const parseEmailList = (value) =>
  String(value || "")
    .split(/[\s,;]+/)
    .map((entry) => entry.trim())
    .filter(Boolean);

/** The entries that are not usable addresses, for telling the user which one to fix. */
export const invalidEmailsIn = (value) =>
  parseEmailList(value).filter((entry) => !isValidEmail(entry));
